import * as React from "react";
import { ErrorMessage, Form, Formik } from "formik";
import {
  CircularProgress,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
  Backdrop, Alert
} from "@mui/material";

import * as Yup from "yup";
import { Fragment } from "react";
import SendIcon from "@mui/icons-material/Send"
import RequiredAsterisk from "../components/RequiredAsterisk";
import { Col, Row } from "react-bootstrap";
import { OwnerAddress } from "./components/OwnerAddress";
import { InstallAddress } from "./components/InstallAddress";
import { useSTCProcessing } from "../hooks/useStcProcessing";

const TradingStc = (props) => {
  const { processSTCForPostcode } = useSTCProcessing();

  const handleChangeOwner = (event) => {
    const owner = event.target.value;
    props.setData((prev) => ({ ...prev, is_property_owner: owner }))
    if (owner === '0') {
      window.confirm('Only the property owner can claim an STC rebate on a renewable installation. The STC authority requires owner address and install address.');
    }

  };

  const handleSubmit = (values) => {
    props.next(values, true);
  };


  let mySchema = (data) => {

    let baseSchema1 = {};
    let baseSchema2 = {};
    let baseSchema3 = {};
    let baseSchema4 = {};

    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

    baseSchema1 = {

      is_property_owner: Yup.string().required('Is the occupier the property owner is required.'),
      owner_firstname: Yup.string().required('Firstname is required.'),
      owner_lastname: Yup.string().required('Lastname is required.'),
      owner_phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid').min(10, 'Phone number must be 10 chars. eg: 0812345678 or 0401234567.').max(10, 'Phone number is too long.').required('Phone number is required'),
      owner_email: Yup.string().email('Your email is invalid.').required('Email address is required.').max(45, 'You email address is too long!'),
      owner_street: Yup.string().required('Owner Street is required.'),
      owner_suburb_town: Yup.string().required('Owner Suburb or Town is required.'),
      owner_state: Yup.string().oneOf(["ACT", "QLD", "SA", "NT", "QLD", "VIC", "WA", "NSW", "TAS"]).required('You must select an Oz state!!'),
      owner_postcode: Yup.number().min(799, 'Postcode is out of range').max(9999, 'Postcode out of range.').required('Owner Postcode is required.'),
      installation_building_height: Yup.string().required('Installation Building Height is required.'),
      installation_building_type: Yup.string().required('Installation Building Type or Town is required.'),
      existing_hws_type: Yup.string().required('Existing HWS Type is required.'),
      have_second_hw_system: Yup.string().required('Is there more than one HWS at this address is required.'),
      registered_for_gst: Yup.string().required('Is the property owner registered for GST is required.'),

    };


    if (data.is_property_owner === '0') {
      baseSchema2 = {
        install_firstname: Yup.string().required('Install Firstname is required.'),
        install_lastname: Yup.string().required('Install Lastname is required.'),
        install_phone: Yup.string().matches(phoneRegExp, 'Install Phone number is not valid').min(10, 'Phone number must be 10 chars. eg: 0812345678 or 0401234567.').max(10, 'Phone number is too long.').required('Phone number is required'),
        install_email: Yup.string().email('Install Email is invalid.').required('InstallEmail address is required.').max(45, 'Your Install email address is too long!'),
        install_street: Yup.string().required('Install  street is required.'),
        install_suburb_town: Yup.string().required('Install  Suburb or Town is required.'),
        install_state: Yup.string().oneOf(["ACT", "QLD", "SA", "NT", "QLD", "VIC", "WA", "NSW", "TAS"]).required('Install state must be specified.'),
        install_postcode: Yup.number().min(799, 'Install Postcode is out of range').max(9999, 'Install Postcode out of range.').required('Install Postcode is required.'),
      }
    }


    if (data.registered_for_gst === '1') {
      baseSchema3 = {
        business_name: Yup.string().required('Business Name is required.'),
        business_abn: Yup.string().required('Business ABN is required.')
      };
    }
    if (data.have_second_hw_system === '1') {
      baseSchema4 = {
        location_extra_hot_water_system: Yup.string().required('Please explain the location of the second hot water system.'),
      };
    }

    let Schema = {
      ...baseSchema1,
      ...baseSchema2,
      ...baseSchema3,
      ...baseSchema4
    }

    return Yup.object().shape(Schema);
  }

  return (
    <Formik
      initialValues={props.data}
      onSubmit={handleSubmit}
      validationSchema={mySchema(props.data)}
    >
      {(
        {
          values,
          handleChange,
          handleSubmit,
          errors,
          isSubmitting,
        }
      ) => {

        const enhancedHandleChange = (e) => {
          handleChange(e);

          // Check if it's owner_postcode and process STC
          if (e.target.name === 'owner_postcode' &&
            e.target.value.length === 4 &&
            /^\d{4}$/.test(e.target.value) &&
            props.data.trading_stc === '1') {
            processSTCForPostcode(e.target.value, props.data.trading_stc);
          }
        };

        return (
          <div className="mb-4 p-4 border rounded">


            <Form onSubmit={handleSubmit}>


              <FormLabel id="property-details" className="fw-bold mb-3">Owner Details <RequiredAsterisk /></FormLabel><br /><br />
              <p><strong>Is the occupier the property owner?</strong><RequiredAsterisk /><br /><br /></p>

              <div className="btn-group mb-4" role="group" aria-label="Are you the property owner">

                <input type="radio" className="btn-check" id="is-property-owner-1" autoComplete="off" value="1"
                  name="is_property_owner"
                  checked={values.is_property_owner === '1'}
                  onChange={e => {
                    handleChangeOwner(e);
                    handleChange(e);
                  }}
                />
                <label className="btn btn-outline-primary" htmlFor="is-property-owner-1">YES</label>

                <input type="radio" className="btn-check" id="is-property-owner-0" autoComplete="off" value="0"
                  name="is_property_owner"
                  checked={values.is_property_owner === '0'}
                  onChange={e => {
                    handleChangeOwner(e);
                    handleChange(e);
                  }}
                />
                <label className="btn btn-outline-primary" htmlFor="is-property-owner-0">NO</label>
              </div>

              <Row>
                <Col xs={12} sm={values.is_property_owner === '0' ? 6 : 12}>
                  <OwnerAddress values={values} handleChange={enhancedHandleChange} errors={errors} data={props.data} />
                </Col>

                {
                  values.is_property_owner === '0' &&
                  <Col xs={12} sm={6}>
                    <InstallAddress values={values} handleChange={handleChange} errors={errors} data={props.data} />
                  </Col>
                }
              </Row>


              <div className="mb-4 p-1" style={!!errors.registered_for_gst ? { border: '1px solid red', borderRadius: '5px' } : null}>

                <p><strong>Is the property owner registered for GST?</strong></p>
                <div className="btn-group mb-4" role="group" aria-label="Is the property owner registered for GST?">

                  <input type="radio" className="btn-check" id="registered-for-gst-1" autoComplete="off" value="1"
                    name="registered_for_gst"
                    checked={values.registered_for_gst === '1'}
                    onChange={(e) => {
                      handleChange(e);
                      props.setData((prev) => ({ ...prev, registered_for_gst: e.target.value }));
                    }}
                  />
                  <label className="btn btn-outline-primary" htmlFor="registered-for-gst-1">YES</label>

                  <input type="radio" className="btn-check" id="registered-for-gst-0" autoComplete="off" value="0"
                    name="registered_for_gst"
                    checked={values.registered_for_gst === '0'}
                    onChange={(e) => {
                      handleChange(e);
                      props.setData((prev) => ({ ...prev, registered_for_gst: e.target.value }));
                    }}
                  />
                  <label className="btn btn-outline-primary" htmlFor="registered-for-gst-0">NO</label>
                </div>



                {
                  values.registered_for_gst === '1'
                    ?

                    <Fragment>
                      <FormControl fullWidth className="mb-3">
                        <FormLabel id="business-details" className="fw-bold mb-3">Your Business
                          Details <RequiredAsterisk /></FormLabel>
                        <TextField id="business-name" label="Your Registered Business Name" name="business_name"
                          value={values.business_name}
                          onChange={handleChange}
                          error={!!Boolean(errors.business_name)}
                          helperText={errors.business_name}
                        />
                      </FormControl>
                      <FormControl fullWidth className="mb-3">
                        <TextField label="Your Registered ABN" name="business_abn"
                          value={values.business_abn}
                          onChange={handleChange}
                          error={!!Boolean(errors.business_abn)}
                          helperText={errors.business_abn}
                        />
                      </FormControl>

                      <Alert severity="error" className="border">If you wish to claim STC as a business, The Australian REC registry require an RCTI/STC Invoice made out to iStore prior to installation.</Alert>
                    </Fragment>
                    : null
                }
              </div>


              <div className="mb-2 p-1" style={!!errors.have_second_hw_system ? { border: '1px solid red', borderRadius: '5px' } : null}>

                <p><strong>Is there more than one HWS at this address? <RequiredAsterisk /></strong></p>
                <div className="btn-group mb-4" role="group" aria-label="Is there more than one HWS at this address?">

                  <input type="radio" className="btn-check" id="have-second-hw-system-1" autoComplete="off" value="1"
                    name="have_second_hw_system"
                    checked={values.have_second_hw_system === '1'}
                    onChange={(e) => {
                      handleChange(e);
                      props.setData((prev) => ({ ...prev, have_second_hw_system: e.target.value }));
                    }}
                  />
                  <label className="btn btn-outline-primary" htmlFor="have-second-hw-system-1">YES</label>

                  <input type="radio" className="btn-check" id="have-second-hw-system-0" autoComplete="off" value="0"
                    name="have_second_hw_system"
                    checked={values.have_second_hw_system === '0'}
                    onChange={(e) => {
                      handleChange(e);
                      props.setData((prev) => ({ ...prev, have_second_hw_system: e.target.value }));
                    }}
                  />
                  <label className="btn btn-outline-primary" htmlFor="have-second-hw-system-0">NO</label>
                </div>


                {
                  values.have_second_hw_system === '1'
                    ?
                    <FormControl fullWidth>

                      <TextField multiline rows='3' name="location_extra_hot_water_system"
                        placeholder=" Please explain where the extra hot water system is?"
                        value={values.location_extra_hot_water_system}
                        onChange={handleChange}
                        error={!!Boolean(errors.location_extra_hot_water_system)}
                        helperText={errors.location_extra_hot_water_system}
                      />
                    </FormControl>
                    :
                    null
                }
              </div>

              <FormControl fullWidth className="mb-5 mt-3">
                <InputLabel id="installation-building-height-label">Installation Building Height
                  (Storey)</InputLabel>
                <Select name="installation_building_height" placeholder="Installation Building Height"
                  label="Select Installation Building Height"
                  value={values.installation_building_height}
                  onChange={handleChange}
                  error={!!Boolean(errors.installation_building_height)}
                  labelId="installation-building-height-label"
                  id="installation-building-height"
                >
                  <MenuItem value='1'>Single Storey</MenuItem>
                  <MenuItem value='2+'>Multi Storey</MenuItem>
                </Select>
                <ErrorMessage style={{ letterSpacing: '0.03333em', fontSize: '0.75rem', marginLeft: '14px' }}
                  component="div" name="installation_building_height"
                  className="help-block errors text-danger" />
              </FormControl>

              <FormControl fullWidth className="mb-5">
                <InputLabel id="installation-building-type-label">Installation Building Type</InputLabel>
                <Select name="installation_building_type" placeholder="Installation Building Type"
                  label="Select Installation Building Type"
                  value={values.installation_building_type}
                  onChange={handleChange}
                  error={!!Boolean(errors.installation_building_type)}
                  labelId="installation-building-type-label"
                  id="installation-building-type"
                >
                  <MenuItem value='Residential'>Residential</MenuItem>
                  <MenuItem value='Commercial'>Commercial</MenuItem>
                </Select>
                <ErrorMessage style={{ letterSpacing: '0.03333em', fontSize: '0.75rem', marginLeft: '14px' }}
                  component="div" name="installation_building_type"
                  className="help-block errors text-danger" />
              </FormControl>

              <FormControl fullWidth className="mb-4">
                <InputLabel id="existing-hws-type-label">Existing Hot Water System Type</InputLabel>
                <Select name="existing_hws_type"
                  label="Existing Hot Water System Type"
                  value={values.existing_hws_type}
                  onChange={handleChange}
                  error={!!Boolean(errors.existing_hws_type)}
                  labelId="existing-hws-type-label"
                  id="existing-hws-type"
                  variant="outlined"

                >
                  <MenuItem value='None'>None</MenuItem>
                  <MenuItem value='Electric Instantaneous'>Electric Instantaneous</MenuItem>
                  <MenuItem value='Electric Storage'>Electric Storage</MenuItem>
                  <MenuItem value='Gas Instantaneous'>Gas Instantaneous</MenuItem>
                  <MenuItem value='Gas Storage'>Gas Storage</MenuItem>
                  <MenuItem value='Solar Hot Water System'>Solar Hot Water System</MenuItem>
                  <MenuItem value='Heat Pump'>Heat Pump</MenuItem>
                  <MenuItem value='Wood Fire'>Wood Fire</MenuItem>
                </Select>
                <ErrorMessage style={{ letterSpacing: '0.03333em', fontSize: '0.75rem', marginLeft: '14px' }}
                  component="div" name="existing_hws_type" className="help-block errors text-danger" />

              </FormControl>


              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isSubmitting}
              >
                <CircularProgress color="inherit" />
              </Backdrop>

              <Row spacing={2}>
                <Col xs={12} sm={3}>
                  <Button variant="contained" size="large" type="button"
                    onClick={() => props.prev(values)}>Prev</Button>
                </Col>

                <Col xs={12} sm={9} className="text-end">
                  <Button disabled={isSubmitting} variant="contained" size="large" id="place-order"
                    type="submit"
                    endIcon={<SendIcon />}
                  >
                    Place Order</Button>
                </Col>
              </Row>


            </Form>
          </div>
        );


      }}
    </Formik>
  );
}

export default TradingStc;